import { FuseLoadable } from "@fuse";

export const QueryToolConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: "/app/rPRec/rPRQuery",
      component: FuseLoadable({
        loader: () => import("./Mainworkflow")
      })
    }
  ]
};
